import { ArrowDown, MessageCircle } from "lucide-react";
import { waLink, COMPANY } from "../lib/constants";

export default function Hero() {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] flex items-end overflow-hidden bg-[var(--fb-ink)]"
    >
      {/* Background image */}
      <picture className="absolute inset-0 block no-select">
        <source
          media="(min-width: 768px)"
          srcSet="/photos/hero.webp"
          type="image/webp"
        />
        <source
          media="(min-width: 768px)"
          srcSet="/photos/hero.jpg"
          type="image/jpeg"
        />
        <source srcSet="/photos/hero_mobile.webp" type="image/webp" />
        <img
          src="/photos/hero_mobile.jpg"
          alt="Pérgola amplia construida por Florentin Contractors"
          className="kenburns w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </picture>

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--fb-ink)] via-[var(--fb-ink)]/55 to-[var(--fb-ink)]/35" />
      <div className="absolute inset-0 grain" />

      {/* Top thin marker */}
      <div className="absolute top-24 md:top-28 left-0 right-0 z-10">
        <div className="fb-container flex items-center gap-3">
          <span className="h-px w-10 bg-[var(--fb-accent)]" />
          <span className="text-white/75 text-[11px] tracking-[0.22em] uppercase font-medium">
            Constructora · Argentina
          </span>
        </div>
      </div>

      <div className="relative z-10 fb-container pb-16 md:pb-24 pt-32 md:pt-40 w-full">
        <div className="max-w-4xl">
          <img
            data-testid="hero-logo"
            src="/brand/full.png"
            alt="Florentin Contractors"
            className="w-52 sm:w-64 md:w-80 lg:w-96 h-auto mb-6 md:mb-8 drop-shadow-[0_8px_24px_rgba(0,0,0,0.45)]"
            loading="eager"
          />

          <h1
            data-testid="hero-title"
            className="font-display text-white text-[38px] leading-[1.02] sm:text-5xl md:text-6xl lg:text-[68px] font-medium tracking-tight balance"
          >
            Construcción y remodelación
            <span className="text-[var(--fb-accent)]"> premium</span>
          </h1>

          <p
            data-testid="hero-tagline"
            className="mt-5 md:mt-6 text-white/80 text-sm md:text-base font-medium tracking-[0.18em] uppercase"
          >
            Construcción <span className="text-[var(--fb-accent)]">•</span>{" "}
            Refacciones <span className="text-[var(--fb-accent)]">•</span> Pérgolas
          </p>

          <p
            data-testid="hero-subtitle"
            className="mt-5 md:mt-7 text-white/85 text-base md:text-lg lg:text-xl max-w-2xl pretty leading-relaxed"
          >
            {COMPANY.subtitle}
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              data-testid="hero-cta-whatsapp-btn"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp"
            >
              <MessageCircle className="h-5 w-5" strokeWidth={2.4} />
              Solicitar Presupuesto
            </a>
            <a
              data-testid="hero-cta-portfolio-btn"
              href="#trabajos"
              className="btn-secondary"
            >
              Ver Trabajos
              <ArrowDown className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom meta strip */}
      <div className="absolute bottom-0 inset-x-0 z-10 border-t border-white/10 bg-black/20 backdrop-blur-sm">
        <div className="fb-container py-3 md:py-4 flex items-center justify-between gap-4">
          <div className="hidden md:flex items-center gap-6 text-white/75 text-xs tracking-[0.14em] uppercase">
            <span>Pérgolas</span>
            <span className="w-1 h-1 rounded-full bg-[var(--fb-accent)]" />
            <span>Refacciones</span>
            <span className="w-1 h-1 rounded-full bg-[var(--fb-accent)]" />
            <span>Construcción General</span>
            <span className="w-1 h-1 rounded-full bg-[var(--fb-accent)]" />
            <span>Mantenimiento</span>
          </div>
          <a
            href="#nosotros"
            className="text-white/70 hover:text-white text-xs tracking-[0.18em] uppercase flex items-center gap-2 transition-colors"
          >
            Scroll
            <ArrowDown className="h-3.5 w-3.5 animate-bounce" />
          </a>
        </div>
      </div>
    </section>
  );
}
